<template>
    <div class="container" style="max-width:800px;">
      <div class="row pt-2 text-start mb-2">
          <div class="col-6">
              <h5>
                  <span class="badge rounded-pill text-dark p-2 px-3" style="background:LightBlue">
                  <b>Remarks : หมายเหตุ</b>
                  </span>
              </h5>
          </div>
          <div class="col-6">
              <button type="button" class="btn btn-primary float-sm-end " data-bs-toggle="modal" data-bs-target="#exampleModal" @click="newRecord()" style="width:100px;">New</button>
              <!-- <div class="col float-end "> <input class="btn btn-primary" value="New" @click="newRecord()"></div> -->
          </div>
      </div>
      <div class="row ">
        <div class="col-sm">
            <table id="myRemarkTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;font-size:80%">
                <thead class="text-white" style="background:Navy">
                <tr>
                    <!-- <th >รหัสคลินิก</th> -->
                    <th>แก้ไข</th>
                    <th>ข้อความหมายเหตุ (200 ตัวอักษร)</th>
                    <th>ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datalists" class="py-0" :key="item.id" v-bind:data-id="item.RemarkID" @click="tableChanged($event, item)">
                    <!-- <td class="text-start">{{ item.ReqClinicCode }}</td> -->
                    <td class="">
                        <button type="button" class="btn btn-primary btn-sm py-0 mx-1" id="Edit" data-bs-toggle="modal" data-bs-target="#exampleModal">Edit</button>
                    </td>
                    <td class="text-start">{{ item.Remark }}</td>
                    <td  >
                        <button class="btn btn-danger btn-sm py-0" id="Delete" @click="cancelRecord(item)">Del</button>
                    </td>
                </tr>
                </tbody>
            </table>

            <!-- ปุ่มจัดลำดับก่อนหลัง ในห้องตรวจ -->
            <div class="container" :hidden="_rowsCount <= 1">
              <div class="btn-group" role="group" aria-label="Basic outlined example">
                <button type="button" class="btn btn-outline-primary" title="ย้ายตำแหน่งขึ้น" @click="upNdown('up');">Up</button>
                <button type="button" class="btn btn-outline-primary" title="ย้ายตำแหน่งลง" @click="upNdown('down');">Down</button>
                <button type="button" class="btn btn-primary ms-2" title="จัดเก็บลำดับที่เปลี่ยนแปลง" @click="applySeqItems();">บันทึกลำดับที่จัดเรียง</button>
              </div>
              <p class="mt-2 mb-4" style="font-size:90%">คำแนะนำ : การเรียงลำดับให้แสดงข้อมูลครบทุกแถว โดยการเปลี่ยนจำนวนแถวที่แสดงที่มุมซ้ายด้านบนของตาราง เป็น "Show All entries"</p>
            </div>
        </div>

        <!-- Modal Form -->
        <div id="exampleModal" class="modal" tabindex="-1">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">ป้อนข้อความหมายเหตุ </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body" style="background:LightBlue">
                <form id="fmRoom" @submit.prevent="" >
                    <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                    <input type="text" hidden class="form-control" id="action" placeholder="" name="action" v-model="action" >
                    <input type="text" hidden class="form-control" placeholder="" name="RemarkID" v-model="curRecord.RemarkID" >
                    <div class="row mb-2">
                        <div class="col-1"></div>
                        <div class="col text-start">
                            <label for="Remark" class="mr-sm-2 ">ข้อความหมายเหตุ :</label>
                            <textarea class="form-control" id="Remark" ref="Remark" name="Remark" rows="2" v-model="curRecord.Remark"></textarea>
                            <!-- <input type="text" class="form-control" id="Remark"  placeholder="ชื่อ*" name="Remark" autocomplete="off" v-model="curRecord.Remark" required> -->
                        </div>
                        <div class="col-1"></div>
                    </div>
                    <br>
                </form>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="saveData()">Save changes</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'RemarkView',
  components: {

  },
  data () {
    return {
      datalists: [],
      curRecord: {},
      action: 'new',

      index: 0
    }
  },
  mounted () {
    this.getData()
  },
  computed: {
    // a computed getter
    _rowsCount: function () {
      if (this.datalists === null || typeof this.datalists === 'undefined') { return 0 }
      return this.datalists.length
    }
  },
  methods: {
    // จัดเก็บลำดับที่จัดเรียงใหม่
    applySeqItems () {
      var self = this
      var arrRoom = []
      // แปลงข้อมูลจากฟอร์ม
      var table = document.getElementById('myRemarkTable')
      for (var i = 1; i < table.rows.length; i++) {
        // console.log(table.rows[i].getAttribute('data-id'))
        arrRoom.push({
          RemarkID: table.rows[i].getAttribute('data-id'),
          Seq: i,
          UserID: this.globalUserID
        })
      }
      // console.log(arrRoom)
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/update_remark_seq.php',
        data: { request: JSON.stringify(arrRoom) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกลำดับใหม่เสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            self.$emit('onDataChangedEvent')
          })
        })
        .fail(function (resp) {
          console.log(resp)
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    },
    upNdown (direction) {
      var rows = document.getElementById('myRemarkTable').rows
      var parent = rows[this.index].parentNode
      if (direction === 'up') {
        if (this.index > 1) {
          parent.insertBefore(rows[this.index], rows[this.index - 1])
          // when the row go up the index will be equal to index - 1
          this.index = this.index - 1
        }
      }
      if (direction === 'down') {
        if (this.index < rows.length - 1) {
          parent.insertBefore(rows[this.index + 1], rows[this.index])
          // when the row go down the index will be equal to index + 1
          this.index = this.index + 1
        }
      }
    },
    // แสดงแถบสีว่า เลือก row นี้
    getSelectedRow (event, row) {
      // console.log('row Index :')
      // console.log(event.target.parentNode.rowIndex)
      this.index = event.target.parentNode.rowIndex
      var table = document.getElementById('myRemarkTable')
      for (var i = 1; i < table.rows.length; i++) {
        table.rows[i].style.backgroundColor = 'white'
        table.rows[i].style.color = 'black'
      }
      table.rows[this.index].style.backgroundColor = 'MediumBlue'
      table.rows[this.index].style.color = 'white'
    },
    cancelRecord (item) {
      var self = this
      Swal.fire({
        title: item.Name,
        text: 'คุณแน่ใจหรือไม่...ที่จะลบข้อมูล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/delete_remark.php',
            data: { RemarkID: item.RemarkID }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกลบเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              // self.getData()
              self.$emit('onDataChangedEvent')
            })
          })
        }
      })
    },
    newRecord () {
      this.curRecord = {}
      this.action = 'new'
    },
    tableChanged (event, row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      // console.log(this.curRecord)

      // ================================ //
      //          การจัดลำดับ
      // แถบสี row ที่คลิก
      this.getSelectedRow(event, row)
    },
    getData () {
      MyApiClient.get('getdata/remarks_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.datalists = resp.data.response
          setTimeout(function () { $('#myRemarkTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    saveData () {
      var self = this
      // แปลงข้อมูลจากฟอร์ม
      var x = $('#fmRoom').serializeArray()
      var formData = {}
      $.each(x, function (i, field) {
        $.extend(formData, { [field.name]: field.value })
      })
      // console.log(formData)
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/insert_remark.php',
        data: { request: JSON.stringify(formData) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            // Refresh >> this component only
            // self.getData()
            self.$emit('onDataChangedEvent')
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    }
  }
}
</script>

<style>

</style>
